import Baskerville from './Baskerville';
import PxGrotesk from './PxGrotesk';
import NBAkademie from './NBAkademie';

export default {
  Baskerville,
  PxGrotesk,
  NBAkademie,
};
